import React from 'react';
import styles from './style.module.css';
import IframeResize from "../../../../common/components/iframe-resize";

export default () => (
    <div className={styles.page}>
        <h1 className={'invisible'}>RRIF Payment Calculator</h1>
        <iframe src="https://www.financialcalculators.net/librocu/rrif-payment/" title="RRIF Payment Calculator" scrolling="no" frameBorder="0"> </iframe>
        <IframeResize/>
    </div>
);
